'use strict';

angular.module('internal.applications')
    .controller('InternalApplication', ['$scope', '$rootScope', '$stateParams', 'LicenseRequests', '$uibModal', '$interval', '$q', 'ProcessStatuses', 'LicenseRequestProcess', 'Alerts', function ($scope, $rootScope, $stateParams, LicenseRequests, $uibModal, $interval, $q, ProcessStatuses, LicenseRequestProcess, Alerts) {
        $scope.masterApplication = $stateParams.application;
        $scope.application = $stateParams.application;
        $scope.applicationID = $stateParams.id;
        $scope.applicationLoading = true;
        $scope.intervalLoading = false;
        $scope.deleting = false;

        $scope.setMasterApplication = function (application) {
            $scope.masterApplication = application;
            $scope.application = angular.copy($scope.masterApplication);
        }

        $scope.resetApplication = function () {
            var d = $q.defer();
            if ($scope.masterApplication == null) {
                $scope.masterApplication = {};
            }
            $scope.application = angular.copy($scope.masterApplication);
            d.resolve();
            return d.promise;
        }

        $scope.getApplication = function () {
            $scope.applicationLoading = true;
            $scope.loadApplication().then(function () {
                $scope.applicationLoading = false;
            })
        }

        var stop;
        $scope.loadApplication = function () {
            var d = $q.defer();

            LicenseRequests.getByID($stateParams.id).then(function (application) {
                application.object = {};

                if (application.service_id != null && application.service != null) {
                    application.object.id = application.service_id;
                    application.object.name = application.service.name;
                    application.object.link = "services/show.cfm?serviceID=" + application.service_id;
                    if (application.service.primary_certification != null) {
                        application.object.number = application.service.primary_certification.number;
                        application.object.levels = application.service.primary_certification.level_name;
                    }
                }
                else if (application.vehicle_id != null && application.vehicle != null) {
                    application.object.id = application.vehicle_id;
                    application.object.name = application.vehicle.name;
                    application.object.link = "vehicles/show.cfm?vehicleID=" + application.vehicle_id;
                    if (application.vehicle.primary_certification != null) {
                        application.object.number = application.vehicle.primary_certification.number;
                        application.object.levels = application.vehicle.primary_certification.level_name;
                    }
                }
                else if (application.user_id != null && application.user != null) {
                    application.object.id = application.user_id;
                    application.object.name = application.user.name;
                    application.object.link = "users/summary.cfm?userID=" + application.user_id;
                    if (application.user.primary_certification != null) {
                        application.object.number = application.user.primary_certification.number;
                        application.object.levels = application.user.primary_certification.level_name;
                    }
                }

                $scope.setProcessStatuses(application);

                if (application.current_triggers_firing_count != null && application.current_triggers_firing_count > 0) {
                    // check if the application was modified in the last 45 seconds first
                    if (application.modifiedon != null && (((new Date) - application.modifiedon) < (45 * 1000))) {
                        if (!angular.isDefined(stop)) {
                            stop = $interval(function () {
                                if (!$scope.intervalLoading) {
                                    $scope.intervalLoading = true;
                                    $scope.loadApplication().then(function () {
                                        $scope.intervalLoading = false;
                                    });
                                }
                            }, 5000);
                        }
                    }
                    else {
                        // set the trigger fire count to 0
                        application.current_triggers_firing_count = 0;
                        LicenseRequests.setCurrentTriggerCount($stateParams.id, 0);
                        $scope.stopInterval();
                    }
                }
                else {
                    $scope.stopInterval();
                }

                //Alerts used to be called within the getLicenseRequest sproc, however, it was slowing down the time it took for that sproc to return
                //Instead, this getAlerts call is now made syncronously after the getLicenseRequest takes place
                //Application alerts will also display the service/vehicle/user alerts tied to the application
                Alerts.getAlerts({ license_request_id: $stateParams.id, user_id: application.user_id, service_id: application.service_id, vehicle_id: application.vehicle_id }).then(function (alerts) {
                    application.alerts = alerts;
                    $scope.setMasterApplication(application);
                });

                $scope.setMasterApplication(application);
                d.resolve();
            })
            
            return d.promise;
        }

        $scope.stopInterval = function () {
            if (angular.isDefined(stop)) {
                $interval.cancel(stop);
                stop = undefined;
            }
        };

        $scope.$on('$destroy', function () {
            // Make sure that the interval is destroyed too
            $scope.stopInterval();
        });

        $scope.delete = function () {
            $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'applications/components/application-delete-modal/application-delete-modal.html',
                controller: 'InternalApplicationDeleteModal',
                resolve: {
                    
                }
            }).result.then(function (result) {
                if (result) {
                    $scope.deleting = true;
                    LicenseRequests.delete($scope.applicationID, result).then(function () {
                        $scope.deleting = false;
                        window.location = $rootScope.internalURL + 'license/applications/list.cfm';
                    })
                }
            })
        }

        $scope.statuses = [];
        $scope.vm = {
            selectedStatus: null
        }
        $scope.setProcessStatuses = function (application) {
            $scope.statuses = [];
            $scope.vm.selectedStatus = null;
            ProcessStatuses.get(application.license_id).then(function (statuses) {
                $scope.statuses = statuses;
                $scope.statuses.forEach(function (status) {
                    application.process_statuses.forEach(function (licenseRequestStatus) {
                        if (status.status_id == licenseRequestStatus.status_id && status.process_id == licenseRequestStatus.process_id) {
                            status.name += " (current)";
                        }
                    });
                });
            });
        }

        $scope.processChange = function () {
            var note = "";
            var newStatus = "";

            $scope.statuses.forEach(function (status) {
                if (status.id == $scope.vm.selectedStatus) {
                    newStatus = status;
                }
            });

            if (newStatus != null && !newStatus.name.endsWith("(current)")) {
                $uibModal.open({
                    animation: true,
                    templateUrl: paths.app + 'applications/components/application-process-change-modal/application-process-change-modal.html',
                    controller: 'InternalApplicationProcessChangeModal',
                    resolve: {
                        status: function () {
                            return newStatus;
                        },
                        note: function () {
                            return note;
                        }
                    }
                }).result.then(function (result) {
                    if (result != null) {
                        $scope.applicationLoading = true;
                        LicenseRequestProcess.updateProcess($stateParams.id, newStatus, result.note).then(function (result) {
                            //Update status list to show correct "current" value
                            $scope.loadApplication().then(function () {
                                $scope.vm.selectedStatus = null;
                                $scope.applicationLoading = false;
                            })                            
                        });
                    }
                });
            }
            else {
                $scope.vm.selectedStatus = null;
            }
        }
        
        if ($stateParams.id != null) {
            $scope.getApplication();
        }
        else {
            var application = {};
            $scope.applicationLoading = false;
            $scope.setMasterApplication(application);
        }
    }])
;